module.exports = __webpack_public_path__ + "img/HandMade.1c5c08b2.jpg";